import {UIPlayerColorController} from '../../../../shared/scripts/UIPlayerColorController'
import {ProfileEditAjaxEndPoints} from '../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'
import {Sound} from '../../../../shared/scripts/Sound'
import {UIImagePathController} from '../../../../shared/scripts/UIEnums.ts'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {notificationController} from '../../../../shared/scripts/EntryShared'
import {TranslationKeys, TranslationObject, getNestedTranslation} from '@colonist/i18n'
import {EnumUtils} from '@colonist/utils'
import {PlayerColor} from '@colonist/game-states'

export class UIDefaultPlayerColorController extends UIPlayerColorController {
    constructor() {
        super()
        this.colorSelectionModal = document.getElementById('profile_colorselector_modal') as HTMLDivElement
        this.colorsContainer = document.getElementById('profile_colorselector_container') as HTMLDivElement
        this.colorsGrid = document.getElementById('profile_colorselector_grid') as HTMLDivElement

        this.colorSelectionModal.onclick = (event: MouseEvent) => {
            if(event.target === this.colorSelectionModal) this.hideColorWindow()
        }
        this.setCloseButton()
    }

    protected onColorSelect(color: PlayerColor) {
        Sound.playSound(Sound.SoundType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.HeaderProfile, CA.Label.HeaderProfileClickedChangeColor)
        this.hideColorWindow()
        void this.updatePreferredColor(color)

        const primaryMessage: TranslationObject = {key: 'strings:homePage.header.defaultColorSelector.colorChanged'}
        const playerColorKey: TranslationKeys = `strings:colonistCommon.playerColors.${EnumUtils.getEnumKey(color, PlayerColor)}`
        const colorMessage: TranslationObject = {key: playerColorKey}
        const nestedTranslation = getNestedTranslation(primaryMessage, {color: colorMessage})
        const settlementImage = UIImagePathController.getPlayerColorBuildings(color).settlement

        notificationController.showNotification(settlementImage, nestedTranslation)
    }

    // eslint-disable-next-line class-methods-use-this
    async updatePreferredColor(color: PlayerColor) {
        await ProfileEditAjaxEndPoints.updatePreferredColor(color)
    }

    private setCloseButton() {
        const selectorCloseButton = document.getElementById('profile_colorselector_close') as HTMLDivElement
        selectorCloseButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.hideColorWindow()
        }
    }
}
